import axios from "axios";
import localforage from "localforage";
import * as data from "search-observe-app/plugins/data.js"
import { extendPrototype as startswith } from "localforage-startswith";
import { extendPrototype as remove } from "localforage-removeitems";
import {reactive } from "vue";
startswith(localforage);
remove(localforage);

let appStore = null;
export function setPluginStore(store) {
  appStore = store;
}
const ACCURACY_THRESHOLD = 500;
export default {
  data,

  submitter: [],
  required() {
    return [(v) => !!v || "Required"];
  },

  showMessage(msg) {
    alert(msg);
  },

  submit(submitInfo) {
    let endpoint;
    console.log("submitting data to database");
    if (!("key" in submitInfo)) {
      submitInfo.key = "p";
    }
    if ("endpoint" in submitInfo) {
      endpoint = `${appStore.getters['shared/dbName']}${submitInfo["endpoint"]}`;
    } else {
      endpoint =
        `${appStore.getters['shared/dbName']}/public/${submitInfo.table}/keys/${submitInfo.key}/`;
    }
    if (submitInfo.payload.length) {
      axios
        .post(endpoint, JSON.stringify(submitInfo.payload))
        .then((response) => {
          if (response.status === 200) {
            let rowsInserted = 0;
            for (let i in response.data.message) {
              if (
                response.data.status[i] != "error" &&
                response.data.message[i].search("inserted") > -1
              ) {
                submitInfo.payload[i]["submitted"] = true;
                rowsInserted = rowsInserted + 1;
              }
            }
            this.removeOldRecords(submitInfo);
            appStore.commit("shared/setAttribute", {
              attribute: "submittedMessages",
              value: `${rowsInserted} ${submitInfo.table} records uploaded`,
            }),
            appStore.commit("shared/setUnsavedData", false);
          } else {
            // TODO: failure toast
            appStore.commit("shared/setAttribute", {
              attribute: "submittedMessages",
              value: `Could not upload data to ${submitInfo.table}`,
            });
            console.log("failure toast, response code = " + response.status);
          }
        })
        .catch((err) => {
          console.log("error posting", err);
          appStore.commit("shared/setUnsavedData", true);
        });
    }
    //appStore.commit("setState", { varName: "rowsInserted", value: 0 });
  },

  getApiRefData: function (varName) {
    let endpoint = appStore.getters['shared/dbName'] + "/ref/" + varName + "/";
    this.getApiData(endpoint, varName, "refTables");
  },
  // getDatabaseList: function () {
  //   let endpoint = "managed_databases/";
  //   this.getApiData(endpoint, "ref_hotel", null);
  // },
  getViewApiData: function (varName) {
    let endpoint = `${appStore.getters['shared/dbName']} /public/${varName }/`;
    this.getApiData(endpoint, varName, "views");
  },
  //retrieve data from backend API and store in store and localforage
  getApiData: function (endpoint, varName, holder) {
    let payload = { tableName: varName, tableType: holder };
    axios
      .get(endpoint)
      .then((response) => {
        (payload["records"] = response.data.sort(
          (a, b) => a.sequence - b.sequence
        )), //remove current localforage and replace
          this.deleteLocalTable(payload.tableName);
        this.saveRecords({
          table: payload.tableName,
          records: payload.records,
        });
        //write the records to store
        appStore.dispatch("shared/refreshRecords", payload);
      })
      .catch((err) => {
        console.log(payload.tableName);
        console.log(err);
        if (payload.tableName.includes("ref")) {
          //can't connect so restore from local
          this.restoreRefFromLocal(payload.tableName);
        }
      });
  },
  async restoreFromLocal(tableName) {
    await localforage.startsWith(`${appStore.getters['shared/dbName']}-${tableName}`).then((result) => {
      let records = this.forceFieldTypes(tableName, Object.values(result));
      appStore.dispatch("shared/refreshRecords", {
        tableName: tableName,
        records: records,
        tableType: "dataTables",
      });
    });
  },
  async restoreRefFromLocal(tableName) {
    await localforage.startsWith(`${appStore.getters['shared/dbName']}-${tableName}`).then((result) => {
      let records = this.forceFieldTypes(tableName, Object.values(result));
      appStore.dispatch("shared/refreshRecords", {
        tableName: tableName,
        records: records,
        tableType: "refTables",
      });
    });
  },
  getFields(tableName) {
    switch (tableName) {
      case data.SURVEYEFFORT:
        return data.SURVEYEFFORTFIELDS;
      case data.SURVEYPRIMARY:
        return data.SURVEYPRIMARYFIELDS;
      case data.SURVEYBREADCRUMB:
        return data.SURVEYBREADCRUMBFIELDS;
      case data.SURVEYPRIMARYPHOTO: 
        return data.PHOTOFIELDS;
      case data.SURVEYSECONDARYPHOTO:
        return data.PHOTOFIELDS;
      case data.SURVEYTERTIARYPHOTO:
        return data.PHOTOFIELDS;
      case data.SURVEYSECONDARY:
        return data.SURVEYSECONDARYFIELDS
      }
  },
  forceFieldTypes(tableName, records) {
    let header = this.getFields(tableName);
    if (header !== undefined) {
      for (let item in records) {
        try {
          records[item] = this.forceFieldType(header, records[item]);
        } catch (err) {
          console.log(err);
        }
      }
    }
    return records;
  },
  forceFieldType(header, record) {
    for (let a in record) {
      if (record[a] != null && record[a].length < 1) {
        delete record[a];
        continue;
      }
      if (
        header
          .filter(function (el) {
            return el["type"] === "number";
          })
          .map((a) => a.key)
          .includes(a)
      ) {
        record[a] = Number(record[a]);
      }
      if (
        header
          .filter(function (el) {
            return el["type"] === "boolean";
          })
          .map((a) => a.key)
          .includes(a)
      ) {
        record[a] = String(record[a]);
      }
    }
    return record;
  },
  //check if the survey_ts value is more than 24 hours old and submit === true
  // delete record from local forage if both cases are true.
  async removeOldRecords(submitInfo) {
    let date_cuttoff = new Date(Date.now() - 24 * (60 * 60 * 1000));
    var ts_field;
    if (submitInfo.table.includes("photo")) {
      ts_field = "ts";
    } else {
      ts_field = "survey_ts";
    }
    let to_delete = submitInfo.payload.filter((rec) => {
      return new Date(rec[ts_field]) < date_cuttoff && rec.submitted;
    });
    let these_keys = to_delete.map((record) => {
      return this.tableSpecificKey(submitInfo.table, record);
    });
    localforage.removeItems(these_keys);
  },

  //Delete records based on key matching tablename
  deleteLocalTable(tableName) {
    var myLength = tableName.length;
    Object.keys(localStorage).forEach(function (key) {
      if (key.includes(tableName)) {
        localStorage.removeItem(key);
      }
    });
  },
  //dt is a datetime of the start of the search interval
  findUnfinishedSearch(dt) {
    localforage.startsWith(`${appStore.getters['shared/dbName']}-${data.REFBREADCRUMB}`).then((bread) => {
      let all_breadcrumbs = Object.values(bread).length;
      if (all_breadcrumbs > 2){
        localforage.startsWith(`${appStore.getters['shared/dbName']}-${data.SURVEYEFFORT}`).then((result) => {
          if (Object.values(result).length > 0) {
            let survey_records = Object.values(result)
              .filter(function (el) {
                return new Date(el["survey_ts"]).getDate() === dt.getDate() && el["observer_code"] === appStore.getters['shared/username'];
              })
              .sort((a, b) => new Date(b.survey_ts) - new Date(a.survey_ts));
            let lastSurvey = survey_records.length > 0 ? survey_records[0] : null;
            if (lastSurvey != null) {
              localforage.startsWith(`${appStore.getters['shared/dbName']}-${data.REFBREADCRUMB}`).then((res) => {
                let breadcrumbs = Object.values(res).filter((el) => {
                  return (el.survey_ts = lastSurvey.survey_ts);
                });
                if (
                  breadcrumbs.length > 0 &&
                  breadcrumbs.length < all_breadcrumbs
                ) {
                  appStore.commit("shared/setAttribute", {
                    attribute: "unfinishedSearch",
                    value: lastSurvey,
                  });
                }
              });
            }
          }
        });
      } else { //There aren't any breadcrumbs and we are at-sea
        localforage.startsWith(`${appStore.getters['shared/dbName']}-${data.SURVEYEFFORT}`).then((result) => {
          if (Object.values(result).length > 0) {
            let survey_records = Object.values(result)
              .filter(function (el) {
                return new Date(el["survey_ts"]) > new Date(dt - 16 * (60 * 60 * 1000)) && el["observer_code"] === appStore.getters['shared/username'];
              })
              .sort((a, b) => new Date(b.survey_ts) - new Date(a.survey_ts));
            let lastSurvey = survey_records.length > 0 ? survey_records[0] : null;
            if (lastSurvey != null) {
              appStore.commit("shared/setAttribute", {
              attribute: "unfinishedSearch",
              value: lastSurvey,
              });
             }
            }
          
        });
     }
  })
  },
  //Save Records writes an array of record objects to local forage
  saveRecords(info) {
    info.records.map((r) => this.saveRecord(info.table, r));
  },
  saveRecord(tableName, record) {
    record.table = tableName;
    if (tableName.includes("ref")) {
      return this.saveReferenceTable(tableName, record);
    }
    switch (tableName) {
      case data.SURVEYBREADCRUMB:
        return this.saveBreadCrumbLocally(record);
      case data.SURVEYEFFORT:
        return this.saveSurveyEffortLocally(record);
      case data.SURVEYPRIMARY: 
        return this.saveObservationLocally(tableName, record);
      case data.SURVEYSECONDARY:
        return this.saveObservationLocally(tableName, record);
      case data.SURVEYTERTIARY:
        return this.saveObservationLocally(tableName, record);
    }
  },
  makeNewRecord(table) {
    let fields = this.getFields(table);
    let record = {};
    fields.forEach((field) => {
      record[field.key] = field.default ? record[field.default] : "";
    });
    return record;
  },

  makeNewObservation(table) {
  
    let record = this.makeNewRecord(table);
    //record["observation_ts"] = this.getLocalTimestamp(new Date()); //gets set in form
    record["survey_tablet"] = appStore.getters['shared/tabletCode'];
    record["survey_ts"] = this.provideRecord(data.SURVEYEFFORT)["survey_ts"];
    record["latitude_wgs84"] = this.getLatitude(); //TODO should get set in form not here
    record["longitude_wgs84"] = this.getLongitude();
    appStore.dispatch("shared/addRecord", { table: table, record: record });
    appStore.dispatch("shared/shiftPosition", {
      table: table,
      position: appStore.getters['shared/dataTables'][table].length - 1,
    });
    return record
  },
  newBreadCrumb() {
    let record = {
      survey_tablet: appStore.getters["shared/tabletCode"],
      survey_ts: this.provideRecord(data.SURVEYEFFORT)["survey_ts"],
      breadcrumb_location_code: "",
      latitude_wgs84: this.getLatitude(),
      longitude_wgs84: this.getLongitude(),
      ts: "",
    };
    appStore.dispatch("shared/addRecord", { table: data.SURVEYBREADCRUMB, record: record });
    appStore.dispatch("shared/shiftPosition", {
      table: data.SURVEYBREADCRUMB,
      position: appStore.getters['shared/dataTables'][data.SURVEYBREADCRUMB].length - 1,
    });
    return record;
  },
  newSurveyEffort() {
    let record = this.makeNewRecord(data.SURVEYEFFORT)
  
    record.survey_tablet= appStore.getters["shared/tabletCode"];
    record.observer_code= appStore.getters["shared/username"];
    record.survey_ts= this.getLocalTimestamp(new Date());

    appStore.dispatch("shared/addRecord", { table: data.SURVEYEFFORT, record: record });
    appStore.dispatch("shared/shiftPosition", {
      table: data.SURVEYEFFORT,
      position: appStore.getters['shared/dataTables'][data.SURVEYEFFORT].length - 1,
    });
    //child records change position as well
    appStore.dispatch("shared/shiftPosition", {
      table: data.SURVEYPRIMARY,
      position: -1,
    });
    return record;
  },
  saveLocal: async (key, record) => {
    return localforage
      .setItem(key, JSON.parse(JSON.stringify(record)))
      .then((value) => {
        console.log(value);
        return value;
      })
      .catch((err) => {
        console.log(err);
      });
  },

  //Uses table unique key columns to create a unique id.
  //Uses key fields extracted from table field specifications
  tableSpecificKey(table, record) {
    if (Object.keys(appStore.state.app.refTables).includes(table)) {
      return `${table}${record.code}`;
    } else {
      let keyFields = this.getFields(table)
        .filter((el) => el.keyField === true)
        .map((el) => record[el.key]);
      let ukey = keyFields.join("");
      return `${table}${ukey}`;
    }
  },
  savePhotoLocally(table, photoData) {
    appStore.dispatch("shared/addRecord", { table: table, record: photoData });
    let key = `${appStore.getters['shared/dbName']}-${table}${photoData.ts}`;
    this.saveLocal(key, photoData);
    const payload = {
      filename: photoData.photo_file_name,
      photoData: photoData.data,
    };
    this.submitSinglePhoto(payload);
  },
  saveObservationLocally(table, record) {
    let key = `${appStore.getters['shared/dbName']}-${table}${record.survey_ts}${record.survey_tablet}${record.observation_ts}`;
    this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },
  saveSurveyEffortLocally(record) {
    let key = `${appStore.getters['shared/dbName']}-${data.SURVEYEFFORT}${record.survey_ts}${record.survey_tablet}`;
    this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },
  saveBreadCrumbLocally(record) {
    let key =
    `${appStore.getters['shared/dbName']}-${data.SURVEYBREADCRUMB}${record.survey_ts}${record.survey_tablet}${record.ts}`;
    this.saveLocal(key, record);
    localforage.getItem(key).then((res) => {
      console.log(res);
    });
  },

  saveReferenceTable: async (table, record) => {
    try {
      const value = await localforage.setItem(table + record.code, record);
      return value;
    } catch (err) {
      console.log(err);
      console.log("could not save reference record");
    }
  },
  hasCrumbs(surveyRecord) {
    let filtered = appStore.getters['shared/dataTables'][data.SURVEYBREADCRUMB].filter(function (
      el
    ) {
      return (
        (el["survey_tablet"] === surveyRecord.survey_tablet) &
        (el["survey_ts"] === surveyRecord.survey_ts)
      );
    });
    return filtered.length > 0;
  },
  getLocalTimestamp: function (e) {
    let ts = new Date(e);
    return `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(ts.getDate()).padStart(2, "0")} ${String(
      ts.getHours()
    ).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}:${String(
      ts.getSeconds()
    ).padStart(2, "0")}`;
  },
  provideRecord(tableName) {
    if (appStore.getters['shared/tablePositions'][tableName] == -1) {
      return reactive(this.newRecord(tableName));
    } else {
      return reactive(appStore.getters['shared/dataTables'][tableName][
        appStore.getters['shared/tablePositions'][tableName]
      ]);
    }
  },
  findRecordPosition(table, record) {
    let records = appStore.getters['shared/dataTables'][table];
    let index = -1;
    switch (table) {
      case data.SURVEYEFFORT:
        index = records.findIndex(
          (x) =>
            x.survey_tablet === record.survey_tablet &&
            new Date(x.survey_ts).toISOString() ===
              new Date(record.survey_ts).toISOString()
        );
        break;
    }
    return index;
  },
  setListPosition(table, position) {
    appStore.dispatch("shared/shiftPosition", {
      table: table,
      position: position,
    });
  },
  newRecord(tableName) {
    switch (tableName) {
      case data.SURVEYBREADCRUMB:
        return this.newBreadCrumb();
      case data.SURVEYEFFORT:
        return this.newSurveyEffort();
      case data.SURVEYPRIMARY:
        return this.makeNewObservation(tableName);
      case  data.SURVEYSECONDARY:
        return this.makeNewObservation(tableName);
      case data.SURVEYTERTIARY:
        return this.makeNewObservation(tableName);
      }
  },

  populateReferenceTables() {
    Object.keys(appStore.getters['shared/refTables']).forEach(async (key) => {
      this.getApiRefData(key);
    });
  },
  populateViews() {
    Object.keys(appStore.getters['shared/views']).forEach(async (key) => {
      this.getViewApiData(key);
    });
  },
  clearDataStore() {
    Object.keys(appStore.getters['shared/dataTables']).forEach(async (key) => {
      appStore.dispatch("shared/refreshRecords", {
        tableName: key,
        records: [],
        tableType: "dataTables",
      });
    
    });
  },
  submitData() {
    let tables = appStore.getters['shared/dataTables'];
    this.submitRecords(data.SURVEYEFFORT);
    let submitter = Object.keys(tables).map(
      async (t) => await this.submitRecords(t)
    );

  },
  async submitRecords(table) {
    await localforage.startsWith(`${appStore.getters['shared/dbName']}-${table}`).then((result) => {
      this.submit({
        table: table,
        key: "u",
        payload: this.forceFieldTypes(table, Object.values(result)),
      });
    });
  },
  submitSinglePhoto(payload) {
    const dbName = appStore.getters["shared/dbName"];
    axios.post(`${dbName}/write_photo/`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },
  startWatch: function () {
    let geoOptions = {
      enableHighAccuracy: true,
      maximumAge: 15000,
      timeout: 5000,
    };
    navigator.geolocation.getCurrentPosition(
      this.updateLocation,
      this.locationError,
      geoOptions
    );
    this.watchID = navigator.geolocation.watchPosition(
      this.updateLocation,
      this.locationError,
      geoOptions
    );
  },
  stopWatch: function () {
    navigator.geolocation.clearWatch(this.watchID);
  },
  turnGPSOn: function () {
    if (!appStore.state.shared.gpsOn) {
      this.startWatch();
      appStore.commit("shared/setGPSState", false);
    }
  },
  turnGPSOff: function () {
    if (appStore.state.shared.gpsOn) {
      this.stopWatch();
      appStore.commit("shared/setGPSState", false);
    }
  },
  gpsToggle: function () {
    if (appStore.state.shared.gpsOn) {
      this.startWatch();
    } else {
      this.stopWatch();
    }
  },
  getLatitude() {
    if (appStore.state.shared.coordinates != null) {
      return appStore.state.shared.coordinates.latitude;
    } else {
      return 0.0;
    }
  },
  getLongitude() {
    if (appStore.state.shared.coordinates != null) {
      return appStore.state.shared.coordinates.longitude;
    } else {
      return 0.0;
    }
  },
  updateLocation: function (position) {
    if (position.coords.accuracy < ACCURACY_THRESHOLD) {
      appStore.commit("shared/setCoordinates", position.coords);
    }
  },
  locationError: function (err) {
    console.log("location error: " + err.message);
  },
  asBoolean(strvalue) {
    if (strvalue == "true") {
      return true;
    }
    return false;
  },
  asString(boolval) {
    if (boolval) {
      return "true";
    }
    return "false";
  },
};
